<template>
  <div class="artical-layout">
    <div @click.stop>
      <basis-nav
        :nav-title="navTitle"
        :back="back"
      />
      <!-- 基本信息 -->
      <div class="info">
        <p class="title">{{ item.title }}</p>
        <span class="teacher">老师：{{ teacher.name }}</span>
      </div>
      <div class="artical-wrapper">
        <!-- 内容填充 -->
        <slot />
      </div>
      <!-- 点爱心 + 分享 -->
      <div class="right-operate">
        <div class="icon-wrapper" @click="toggoleStarHandler">
          <van-icon name="like" :class="['like', {star}]" />
          <!-- <p class="count">{{ item.staringCount	}}</p> -->
        </div>
        <div class="icon-wrapper" @click="isShowShare = true">
          <van-icon name="share" class="share" />
          <!-- <p class="count">{{ item.forwardingCount }}</p> -->
        </div>
      </div>
      <div class="operating">
        <!-- 分享操作 -->
        <van-overlay
          class="share"
          :show="isShowShare"
          @click="isShowShare = false"
        >
          <div class="share-image">
            <span class="label">
              点击右上角<br>
              分享给朋友
            </span>
          </div>
        </van-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import { BasisNav } from '@/components/basis'
import { Stars } from '@/api'

export default {
  name: 'ArticalLayout',
  components: { BasisNav },
  props: {
    navTitle: {
      type: String,
      required: true,
      default: ''
    },
    item: {
      type: Object,
      required: true,
      default: () => {}
    },
    back: {
      type: Function,
      required: true
    }
  },
  data: () => ({
    isShowDesc: false,
    isShowShare: false,
    mode: false,
    star: false
  }),
  computed: {
    teacher () {
      return this.item.teacher || {}
    },
    collection () {
      const { name } = this.$route
      return name.split('-')[0]
    },
    id () {
      const { id } = this.$route.params
      return id
    }
  },
  watch: {
    '$route.params.id': {
      handler (newId, oldId) {
        if (newId !== oldId) {
          this.getStar()
        }
      }
    }
  },
  async mounted () {
    this.getStar()
  },
  methods: {
    async getStar () {
      try {
        const { star } = await Stars.checkStar({ collection: this.collection, resourceId: this.id })
        this.star = star
      } catch (error) {
        console.log(error)
      }
    },
    async toggoleStarHandler () {
      try {
        switch (this.star) {
          case true: // 取消收藏
            await Stars.deleteStar({ collection: this.collection, resourceId: this.id })
            this.star = false
            break
          case false: // 加入收藏
            await Stars.addStar({ collection: this.collection, resourceId: this.id })
            this.star = true
            break
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.artical-layout {
  @include wh(100%, 100vh);
  position: relative;
  .info {
    padding: 4px 16px;
    .title {
      @include sc($font-size-xlg, $color-text-heavy);
      @include lw(23px, 400);
      margin-bottom: 8px;
    }
    .teacher {
      @include sc($font-size-base, $color-text-medium);
    }
  }
  .artical-wrapper {
    @include sc($font-size-md, $color-text-heavy);
    text-align: justify;
    padding: 16px;
    line-height:20px;
  }
  .right-operate {
    position: fixed;
    bottom: 40px;
    right: 16px;
    z-index: 99;
    padding: 15px 5px;
    background-color: #fff;
    border-radius: 20px;
    box-shadow: 0 0 10px 0px $color-text-active;
    .icon-wrapper {
      & + .icon-wrapper {
        margin-top: 12px;
      }
      .van-icon {
        @include sc(30px, #000);
        &.like{
          transition: color 0.2s ease;
          &.star {
            color: $color-text-active;
          }
        }
      }
      .count {
        @include sc($font-size-lg, #000);
        @include lw(22px, 400);
        text-align: center;
      }
    }
  }
  .operating {
    .video-desc {
      height: 60%;
      .title {
        @include wh(100%, 48px);
        @include lw(48px, 500);
        @include sc($font-size-lg, $color-text-heavy);
        text-align: center;
        border: 1px solid #E8EAEB;
      }
      .des-detail {
        padding: 16px;
        white-space: break-spaces;
      }
    }
    .share {
      z-index: 999;
      .share-image {
        @include wh(100vw, 100vh);
        background: url('~@/assets/images/video/share.png') no-repeat;
        background-position: top 10px right 25px;
        background-size: 162px 230px;
        position: relative;
        .label {
          @include sc($font-size-lg, #fff);
          @include lw(22px, 400);
          letter-spacing: 1px;
          position: absolute;
          left: 100px;
          top: 250px;
          &::after {
            @include wh(26px, 26px);
            @include sc($font-size-xlg, #000);
            @include lw(16px, 600);
            content: "...";
            border-radius: 50%;
            background-color: #fff;
            text-align: center;
            vertical-align: top;
            position: absolute;
            right: -32px;
            top: 0;
          }
        }
      }
    }
  }
}
</style>
